<script setup lang="ts">
import { RouterLink } from 'hybridly/vue'

const props = defineProps<{
	competitors: Paginator<App.Data.Competitor.CompetitorData>
	filters: App.Data.Competitor.SearchCompetitorData
}>()

const filterForm = ref(props.filters)
watchDebounced(
	filterForm.value,
	() => {
		router.get(route('competitors.index'), {
			data: filterForm.value,
			preserveState: true,
		})
	},
	{ debounce: 200, maxWait: 5000 },
)

const { copy, isSupported } = useClipboard({ legacy: true })
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper>
		<div class="mb-3 flex flex-wrap justify-between gap-3 border-b pb-3">
			<div class="max-w-sm grow">
				<ui-input v-model="filterForm.keyword as string" class="w-full" :placeholder="t('app.search_placeholder')" />
			</div>

			<ui-button :as="RouterLink" :href="route('competitors.create')" variant="default">
				{{ t('app.buttons.add_new') }}
				<i-ph-plus-bold />
			</ui-button>
		</div>

		<div>
			<template v-if="props.competitors.data.length === 0 && !props.filters">
				<p class="text-muted-foreground text-center text-sm">
					{{ t('views.competitors.index.empty_state') }}
				</p>
			</template>
			<template v-else>
				<ui-table>
					<ui-table-header>
						<ui-table-row>
							<ui-table-head>{{ t('validation.attributes.name') }}</ui-table-head>
							<ui-table-head>{{ t('validation.attributes.store_url') }}</ui-table-head>
							<ui-table-head />
						</ui-table-row>
					</ui-table-header>
					<ui-table-body>
						<template v-if="props.competitors.data.length > 0">
							<ui-table-row v-for="competitor in props.competitors.data" :key="competitor.uuid">
								<ui-table-cell>
									<div class="flex items-center gap-2">
										<ui-avatar-initials :name="competitor.name" class="size-8 rounded-md" :style="{ '--avatar-background': competitor.brand_color_foreground, '--avatar-foreground': competitor.brand_color }" />
										<span>{{ competitor.name }}</span>
									</div>
								</ui-table-cell>
								<ui-table-cell>
									<div class="flex items-center gap-2">
										<span>{{ competitor.store_url }}</span>
										<template v-if="isSupported">
											<ui-tooltip>
												<ui-tooltip-trigger>
													<i-ph-link-bold class="text-primary cursor-pointer" @click="copy(competitor.store_url)" />
												</ui-tooltip-trigger>
												<ui-tooltip-content>
													{{ t('app.buttons.copy_url') }}
												</ui-tooltip-content>
											</ui-tooltip>
										</template>
									</div>
								</ui-table-cell>
								<ui-table-cell class="text-right">
									<ui-button :as="RouterLink" :href="route('competitors.edit', { competitor: competitor.uuid })" variant="link">
										{{ t('app.buttons.edit') }}
									</ui-button>
								</ui-table-cell>
							</ui-table-row>
						</template>
						<ui-table-empty v-else :colspan="3">
							<p>{{ t('views.competitors.index.no_results') }}</p>
						</ui-table-empty>
					</ui-table-body>
				</ui-table>

				<pagination :links="props.competitors.links" />
			</template>
		</div>
	</content-wrapper>
</template>
